export const COLOR_PALETTES = [
  '#32C569',
  '#22A2F1',
  '#AF71D8',
  '#E35252',
  '#ffa327',
  '#95ce51',
  '#d8804f',
  '#7598ff',
  '#ca7be1',
  '#06d3a5',
  '#8f92a2',
  '#51cbe3',
]
